const LoadingLine = ({ description = "Lade..." }: { description: string }) => {
  return <span className="skeleton skeleton-text">{description}</span>;
};
export default LoadingLine;
